import { pathBuilder } from 'config/paths/index';

export const root = '/tickets';
export default pathBuilder(root);
